import { LayoutElement } from "../layoutelement.model";

export class Raster extends LayoutElement {
  RasterOptions: any;
}
